import AccessDenied from './ui/accessDenied/accessDenied';
import AccessNotAvailable from './ui/accessNotAvailable/accessNotAvailable';

export { AccessNotAvailable };
export default AccessDenied;
